import {
  ADMIN_UPDATE_EVENT_SUCCESS, ADMIN_UPDATE_EVENT_FAILURE
} from '../actions/events';

let adminEventReducer = (state = [], action) => {
	switch(action.type) {
    // case ADMIN_UPDATE_EVENT_SUCCESS:
    // 	console.log('filtered events reducer admin update event success!', action.event);
    //   console.log(state);

    //   return state;
    // case ADMIN_UPDATE_EVENT_FAILURE:
    // 	console.log('filtered events reducer admin update event failure!');
    //   return state;
    default:
      return state;
  }
}

export default adminEventReducer
